// removed by extract-text-webpack-plugin
module.exports = {"container":"_3wsPlbSf7CyWlxc9-XBTAd","state":"_1SRQxYf6qg6kQzlEPYAWFY"};


//////////////////
// WEBPACK FOOTER
// ./src/App/Pages/Documents/Document/SendToSign/OwnerView/Buttons/TemplateButtons/styles.css
// module id = 2835
// module chunks = 0